/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React, { Fragment, memo } from 'react';

import { css, jsx, keyframes } from '@compiled/react';

const fadeIn = keyframes({
	from: {
		opacity: 0,
	},
	to: {
		opacity: 1,
	},
});

const animatedContainerStyles = css({
	animation: `${fadeIn} 700ms cubic-bezier(0.3,0,0.8,0.15) forwards`,
	opacity: 0,
});

export const AnimatedContainer = memo(
	({
		children,
		isStreaming = false,
	}: {
		children: React.ReactNode;
		isStreaming?: boolean;
	}) => {
		if (!isStreaming) {
			return <Fragment>{children}</Fragment>;
		}

		return <div css={animatedContainerStyles}>{children}</div>;
	},
);

AnimatedContainer.displayName = 'AnimatedContainer';
